import { Constants } from '@leverege/molten';
import Views from './views/PluginSetup.js';
import Renderers from './renderers/PluginSetup.js';
import OpenApiMutators from './openApiMutator/PluginSetup.js';
import OpenApiAnalyzer from './initializers/OpenApiAnalyzer.js';
import Filters from './filters/PluginSetup.js';
function install(molten) {
  molten.addPlugin(Constants.INITIALIZER, OpenApiAnalyzer);
  Views.install(molten);
  Renderers.install(molten);
  OpenApiMutators.install(molten);
  Filters.install(molten);
}
export default {
  install
};